import React, { useState, useEffect, useRef } from "react";
import { ImageUrlPrefix } from "../../../../labels";
import { Download } from "@mui/icons-material";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AxiosInstance } from "../../../../axios";
// import moment from "moment";
import { validateForms } from "./validation";
// import ReadViewSubject from "./ReadViewSubject";
import Loader from "../../Loader";
import toast from "react-hot-toast";

export default function FaclityDetailProfile(props) {
  const modalCloseRef = useRef(null);
  const navigate = useNavigate();
  const [staffType, setStaffType] = useState(0);
  const [addJob, setAddJob] = useState([]);
  const [lists, setLists] = useState({
    FirstName: "",
    LastName: "",
    Fathername: "",
    DOB: "",
    age: 0,
    PlaceBirth: "",
    gender: "Male",
    MaritalStatus: "Single/Unmarried",
    Spouse: "",
    Occupation: "",
    Mobile: "",
    WhatsAppNumber: "",
    ContactNumber: false,
    emailaddress: "",
    Profilephoto: null,
    aadharNo: "",
    aadharCardphoto: null,
    panNo: "",
    panPhoto: null,
    BuildingNumberPresent: "",
    BuildingNumberPresent: "",
    StreetNamePresent: "",
    AreaPresent: "",
    LandmarkPresent: "",
    districtPresent: "",
    CityPresent: "",
    statePresent: "",
    PostPresent: "",
    TalukPresent: "",
    PincodePresent: 0,
    SamePresentAddress: false,
    BuildingNumberPermanent: "",
    StreetNamePermanent: "",
    AreaPermanent: "",
    LandmarkPermanent: "",
    CityPermanent: "",
    districtPermanent: "",
    statePermanent: "",
    PincodePermanent: 0,
    PostPermanent: "",
    TalukPermanent: "",
    spq: "",
    prevTeachexp: "Yes",
    workingexp: "",
    teachexp: "",
    Teaching_ex_file: null,
    working_ex_file: null,
    teachType: "",
    designation: "",
    USub: [],
    DJoin: "",
    VoiceOpinion: "",
    Verify: false,
    faculty_id: "",
    status: 0,
    comments: "",
    Adminstatus: "",
    remarks: "",
    original_aadhar_path: null,
    original_profile_path: null,
    original_caste_path: null,
    original_pan_path: null,
    original_workexp: null,
    original_teachexp: null,
    location_name: "",
    location: "",
  });
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }

  const [remarks, setRemarks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  //education useState
  const [educationQualification, setEducationQualification] = useState(["UG"]);
  //education useState
  const [sslcCerficates, setSslcCerficates] = useState([
    {
      name: "UG",
      UGCertificateNumber: "",
      UGYearpassing: "",
      UGDegree: "",
      UGMajor: "",
      UGMarksPercentage: "",
      UGClassName: "",
      UGNameInstitute: "",
      UG_Path: null,
      original_file_path: null,
    },
    {
      name: "PG",
      PGCertificateNumber: "",
      PGYearpassing: "",
      PGDegree: "",
      PGMajor: "",
      PGMarksPercentage: "",
      PGClassName: "",
      PGNameInstitute: "",
      PG_Path: null,
      original_file_path: null,
    },
    {
      name: "Integrated PG",
      IPCertificateNumber: "",
      IPYearpassing: "",
      IPDegree: "",
      IPMajor: "",
      IPMarksPercentage: "",
      IPClassName: "",
      IPNameInstitute: "",
      IP_Path: null,
      original_file_path: null,
    },
    {
      name: "phd",
      PHDCertificateNumber: "",
      PHDYearpassing: "",
      PHDDegree: "",
      PHDMajor: "",
      PHDMarksPercentage: "",
      PHDClassName: "",
      PHDNameInstitute: "",
      PHD_Path: null,
      original_file_path: null,
    },
    {
      name: "Diploma",
      DCertificateNumber: "",
      DYearpassing: "",
      DDegree: "",
      DMajor: "",
      DMarksPercentage: "",
      DClassName: "",
      DNameInstitute: "",
      D_Path: null,
      original_file_path: null,
    },
    {
      name: "Professional Courses",
      PCCertificateNumber: "",
      PCYearpassing: "",
      PCDegree: "",
      PCMajor: "",
      PCMarksPercentage: "",
      PCClassName: "",
      PCNameInstitute: "",
      PC_Path: null,
      original_file_path: null,
    },
    {
      name: "Others",
      OtCertificateNumber: "",
      OtYearpassing: "",
      OtDegree: "",
      OtMajor: "",
      OtMarksPercentage: "",
      OtClassName: "",
      OtNameInstitute: "",
      Ot_Path: null,
      original_file_path: null,
    },
  ]);
  const [error, setError] = useState([]);
  //technical qualification
  const [techQualification, setTechQualification] = useState([
    {
      id: 1,
      name: "",
      level: "",
      lang: "",
      Cnum: "",
      grade: "",
      year: "",
      file: "",
    },
  ]);
  //date and time convert to normal data
  const dobCon = (userdate) => {
    if (!userdate) {
      return ""; // Handle empty input
    }
    const date = new Date(userdate);
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return ""; // Handle invalid date
    }
    // Extract the year, month, and day components
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const day = String(date.getUTCDate()).padStart(2, "0");
    // Format the date as "YYYY-MM-DD"
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  useEffect(() => {
    fetchStaffDetails();
  }, []);

  const fetchStaffDetails = async () => {
    try {
      setIsLoading(true);

      const res = await AxiosInstance.post("api/staff/view", {
        user_id: props.userId,
        staff_id: props.staff_id,
      });

      const userinfo = res.data.data;
      const PersonDetails = {
        FirstName: userinfo.first_name,
        LastName: userinfo.last_name,
        Fathername: userinfo.father_name,
        MotherName: userinfo.mother_name,
        Profilephoto: userinfo.profile_path ?? null,
        DOB: userinfo.dob ? dobCon(userinfo.dob) : "",
        PlaceBirth: userinfo.place_of_birth,
        age: userinfo.age,
        gender: userinfo.gender,
        MaritalStatus: userinfo.marital_status,
        Spouse: userinfo.spouse_name,
        Occupation: userinfo.spouse_ocp,
        aadharNo: userinfo.aadhar_no,
        aadharCardphoto: userinfo.aadhar_path
          ? userinfo.aadhar_path.split("/").pop()
          : null,
        panNo: userinfo.pan_no,
        panPhoto: userinfo.pan_path ? userinfo.pan_path.split("/").pop() : null,
        original_aadhar_path: userinfo.original_aadhar_path,
        original_profile_path: userinfo.original_profile_path,
        original_pan_path: userinfo.original_pan_path,
        Mobile: userinfo.mobile_no,
        WhatsAppNumber: userinfo.whatsapp_no,
        ContactNumber: userinfo.contact_type !== 0,
        emailaddress: userinfo.email,
        spq: userinfo.special_qualification,
        faculty_id: userinfo.faculty_id,
        status: userinfo.status,
        prevTeachexp: userinfo.experience === 1 ? "Yes" : "NO",
        workingexp: userinfo.working_exp,
        teachexp: userinfo.teaching_exp,
        working_ex_file: userinfo.working_exp_filepath,
        Teaching_ex_file: userinfo.teaching_exp_filepath,
        original_workexp: userinfo.original_workexp,
        original_teachexp: userinfo.original_teachexp,
        designation: userinfo.designation,
        teachType: userinfo.is_eligible_class === 0 ? "0" : "1",
        DJoin: dobCon(userinfo.aiasa_doj),
        VoiceOpinion: userinfo.feedback,
        location_name: userinfo.staff_loc_name,
        location: userinfo.staff_loc_id,
      };
      setStaffType(userinfo?.staff_type);
      const addj = userinfo?.job_info?.map((item, index) => ({
        id: index + 1,
        department: item.department || "",
        department_id: item.department_id || "",
        designation_id: item.designation_id || "",
        exp_designation: item.exp_designation || "",
      }));
      setAddJob(addj);
      setRemarks(userinfo.remarks);

      userinfo.address.forEach((obj) => {
        const prefix = obj.address_type === 1 ? "Present" : "Permanent";
        PersonDetails[`Same${prefix}Address`] = obj.same_address === 0;
        PersonDetails[`BuildingNumber${prefix}`] = obj.address1;
        PersonDetails[`StreetName${prefix}`] = obj.address2;
        PersonDetails[`Area${prefix}`] = obj.address3;
        PersonDetails[`Landmark${prefix}`] = obj.landmark;
        PersonDetails[`district${prefix}`] = obj.district_name;
        PersonDetails[`City${prefix}`] = obj.city;
        PersonDetails[`state${prefix}`] = obj.state_name;
        PersonDetails[`Post${prefix}`] = obj.post_name;
        PersonDetails[`Taluk${prefix}`] = obj.taluk;
        PersonDetails[`Pincode${prefix}`] = obj.postal_code;
      });

      setLists(PersonDetails);

      const edq = userinfo.edu
        .filter((item) => item.qualification_type === "EDQ")
        .map((obj) =>
          obj.name === "sslc" ? "SSLC" : obj.name === "hsc" ? "HSC" : obj.name
        );

      setEducationQualification(edq);

      const sslcCert = userinfo.edu.filter(
        (item) => item.qualification_type === "EDQ"
      );

      sslcCert.forEach((el) => {
        const matchingCertificate = {
          name: el.name,
          original_file_path: el.original_file_path,
        };

        const pathKey = `${
          el.name === "UG"
            ? "UG"
            : el.name === "PG"
            ? "PG"
            : el.name === "Integrated PG"
            ? "IP"
            : el.name === "phd"
            ? "PHD"
            : el.name === "Diploma"
            ? "D"
            : el.name === "Professional Courses"
            ? "PC"
            : "Ot"
        }`;

        Object.assign(matchingCertificate, {
          [`${pathKey}CertificateNumber`]: el.certificate_no,
          [`${pathKey}Yearpassing`]: el.year_of_passing,
          [`${pathKey}Degree`]: el.degree_name,
          [`${pathKey}Major`]: el.major_subject,
          [`${pathKey}MarksPercentage`]: el.marks_percentage,
          [`${pathKey}ClassName`]: el.grade,
          [`${pathKey}NameInstitute`]: el.institute,
          [`${pathKey}_Path`]: el.certificate_path
            ? el.certificate_path.split("/").pop()
            : "",
        });

        setSslcCerficates((prevState) =>
          prevState.map((q) => (q.name === el.name ? matchingCertificate : q))
        );
      });

      const teach = userinfo.edu
        .filter((item) => item.qualification_type === "THQ")
        .map((el, index) => ({
          id: index === 0 ? 1 : index + 1,
          name: el.name,
          level: el.level,
          lang: el.edu_medium,
          Cnum: el.certificate_no,
          grade: el.grade,
          year: el.year_of_passing,
          original_file_path: el.original_file_path,
          kComputer: el.kdg_in_com,
          file: el.certificate_path ? el.certificate_path.split("/").pop() : "",
        }));

      setTechQualification(teach);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      return error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForms(lists);
    if (Object.keys(errors).length === 0) {
      try {
        const reqdata = {
          user_id: props.userId,
          updated_by: userid,
          status: lists.Adminstatus,
          comments: lists.comments,
        };
        const response = await AxiosInstance.post(
          "api/staff/approval",
          reqdata
        );
        if ((response.data.status = true)) {
          toast.success(response.data.message);
          navigate("/Faculties");
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error(error.response.data.message);
      }
    } else {
      setError(errors);
    }
  };

  const handleRemarks = () => {
    if (lists.remarks !== "" && lists.remarks !== null) {
      let rem = {
        staff_id: props.staff_id,
        comments: lists.remarks,
        created_by: userid,
      };

      AxiosInstance.post("api/staff/remarks", rem)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);
            setLists((prev) => ({ ...prev, remarks: "" }));
            const modal_close = modalCloseRef.current;
            if (modal_close) modal_close.click();
            fetchStaffDetails();
            // navigate(
            //   `/Faculties/FacultyDetailView/${props.userId}/${props.staff_id}/4`
            // );
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || "Something went wrong");
        });
    } else {
      setError((prev) => ({
        ...prev,
        remarks: "Please fill remarks",
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "Adminstatus") {
      if (checked) {
        setLists((prevFields) => ({
          ...prevFields,
          [name]: value,
        }));
        setError({
          ...error,
          [name]: "",
        });
      }
    } else {
      setLists((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));
      setError({
        ...error,
        [name]: "",
      });
    }
  };
  const UpgradeHandle = () => {
    const state = {
      upgrade: 1,
    };
    navigate(`/Faculties/addfaculty/${0}/${props.userId}`, { state });
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={
        props.activeTab === 4
          ? "container-fluid  global_container p-0 BathDet"
          : "container-fluid  global_container p-0 hide "
      }
      style={{ marginTop: 0, marginBottom: 0 }}
      id="ex2-content"
    >
      <div
        className={
          props.activeTab === 4
            ? "tab-pane fade show active col-md-12"
            : "tab-pane fade col-md-12 "
        }
      >
        {props.from === "ADMIN" && (
          <div className="row">
            <div className="col-md-12 col-12 ListBtn d-flex justify-content-end">
              <ul className="List-Button d-flex p-0 m-0">
                <li className="ListBtnItems d-flex align-items-center justify-content-center">
                  <Link
                    to="javascript:void(0)"
                    className="primaryButton d-flex align-items-center justify-content-center text-center w-100"
                    variant="primary"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    {/* <span className="material-icons me-2 fs-4 align-middle text-white">
                        add_circle
                      </span> */}
                    Add Remarks
                  </Link>
                </li>
                {staffType === 3 && (
                  <li className="ListBtnItems ms-2 d-flex align-items-center justify-content-center">
                    <Link
                      to="javascript:void(0)"
                      onClick={UpgradeHandle}
                      className="primaryButton d-flex align-items-center justify-content-center text-center"
                      variant="primary"
                    >
                      Upgrade to Teaching Faculty
                    </Link>
                  </li>
                )}

                <li className="ListBtnItems">
                  <Link
                    to={`/facultyProfile/${props.userId}`}
                    // to={`${
                    //   staffType === 0
                    //     ? "/facultyProfile"
                    //     : "/NonFacultyProfile"
                    // }/${props.userId}`}
                    className="primaryButton d-flex align-items-center"
                    variant="primary"
                  >
                    {/* <span className="material-icons me-1 fs-5 align-middle">
                        border_color
                      </span> */}
                    {staffType === 0
                      ? "Edit Faculty Profile"
                      : staffType === 1
                      ? "Edit Staff Profile"
                      : "Edit Panel Member Profile"}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        )}

        <fieldset className="mt-3">
          <legend className="w-auto">Basic Details</legend>
          <div className="row mb-3">
            {/* LEFT SIDE: Details */}
            <div className="col-md-9">
              <div className="row">
                <div className="col-lg-4 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">First Name</p>
                    <p className="confirm_value my-1">
                      {lists.FirstName || ""}
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Last Name</p>
                    <p className="confirm_value my-1">
                      {lists.LastName || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Father's Name/Guardian's Name
                    </p>
                    <p className="confirm_value my-1">
                      {lists.Fathername || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Date of Birth</p>
                    <p className="confirm_value my-1"> {lists.DOB || "-"}</p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Age</p>
                    <p className="confirm_value my-1">{lists.age || "-"}</p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Gender</p>
                    <p className="confirm_value my-1">{lists.gender || "-"}</p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Place of Birth</p>
                    <p className="confirm_value my-1">
                      {lists.PlaceBirth || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Marital Status</p>
                    <p className="confirm_value my-1">
                      {lists.MaritalStatus || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Name of the Spouse</p>
                    <p className="confirm_value my-1">{lists.Spouse || "-"}</p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Occupation of the Spouse
                    </p>
                    <p className="confirm_value my-1">
                      {lists.Occupation || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Status</p>
                    <p className="confirm_value my-1">
                      {lists.status === 0 && <span>Email Sent</span>}
                      {lists.status === 1 && <span>Waiting For Approval</span>}
                      {lists.status === 4 && <span>Active</span>}

                      {(lists.status === 2 || lists.status === 3) && (
                        <span>InActive</span>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE: Image */}
            <div className="col-md-3 d-flex justify-content-center align-items-center">
              {/* 
                <div id="profilephotos"> */}
              {lists.Profilephoto && (
                <img
                  className="profile_pic"
                  src={`${ImageUrlPrefix}/${lists.Profilephoto}`}
                  alt="Profile"
                  //             style={{
                  //   width: "150px",
                  //   height: "150px",
                  //   objectFit: "contain",
                  //   borderRadius: "50%",
                  //   border: "1px solid #ccc",
                  //   padding: "4px",
                  //   backgroundColor: "#fff",
                  // }}
                />
              )}
              {/* </div> */}
            </div>
          </div>
        </fieldset>

        <fieldset className="mt-3">
          <legend className="w-auto">Contact details</legend>
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Phone Number</p>
                    <p className="confirm_value my-1">{lists.Mobile || "-"}</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">WhatsApp Number</p>
                    <p className="confirm_value my-1">
                      {lists.WhatsAppNumber || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Email ID</p>
                    <p className="confirm_value my-1">
                      {lists.emailaddress || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset className="mt-3">
          <legend className="w-auto">ID Proofs</legend>
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">AADHAR Number</p>
                    <p className="confirm_value my-1">
                      {lists.aadharNo || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      {" "}
                      Upload AADHAR Card
                      {lists.aadharCardphoto && (
                        <a href={`${ImageUrlPrefix}/${lists.aadharCardphoto}`}>
                          {" "}
                          <Download className="download_icon" />
                        </a>
                      )}
                    </p>
                    <p className="confirm_value my-1">
                      {lists.original_aadhar_path || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> PAN Number</p>
                    <p className="confirm_value my-1">{lists.panNo || "-"}</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      {" "}
                      Uploaded PAN Card
                      {lists.panPhoto && (
                        <a href={`${ImageUrlPrefix}/${lists.panPhoto}`}>
                          {" "}
                          <Download className="download_icon" />
                        </a>
                      )}
                    </p>
                    <p className="confirm_value my-1">
                      {lists.original_pan_path || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <div className="row">
          {/* Present Address */}
          <div className="col-md-6">
            <fieldset className="mt-3">
              <legend className="w-auto">Present Address</legend>
              <div className="row mb-3">
                <div className="col-md-12">
                  <div className="forms mb-2">
                    <p className="confirm_label m-0">Present Address</p>
                    <p className="confirm_value my-1">
                      <span className="">
                        {lists.BuildingNumberPresent || "-"}
                        {lists.BuildingNumberPresent ? ", " : ""}
                        {lists.StreetNamePresent || "-"}
                      </span>
                    </p>
                  </div>

                  <div className="forms mb-2">
                    <p className="confirm_value my-1">
                      <span className="">
                        {lists.AreaPresent || "-"}
                        {lists.AreaPresent ? ", " : ""}
                        {lists.LandmarkPresent || "-"}
                      </span>
                    </p>
                  </div>

                  <div className="forms mb-2">
                    <p className="confirm_value my-1">
                      {" "}
                      <span className="">
                        {lists.TalukPresent || "-"}
                        {lists.TalukPresent ? ", " : ""}
                        {lists.PostPresent || "-"}
                      </span>
                    </p>
                  </div>

                  <div className="forms mb-2">
                    <p className="confirm_value my-1">
                      {" "}
                      <span className="">
                        {lists.PincodePresent || "-"}
                        {lists.PincodePresent ? ", " : ""}
                        {lists.CityPresent || "-"}
                      </span>
                    </p>
                  </div>

                  <div className="forms mb-2">
                    <p className="confirm_value my-1">
                      <span className="">
                        {lists.districtPresent || "-"}
                        {lists.districtPresent ? ", " : ""}
                        {lists.statePresent || "-"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>

          {/* Permanent Address */}
          <div className="col-md-6">
            <fieldset className="mt-3">
              <legend className="w-auto">Permanent Address</legend>
              <div className="row mb-3">
                <div className="col-md-12">
                  <div className="forms mb-2">
                    <p className="confirm_label m-0">Permanent Address</p>
                    <p className="confirm_value my-1">
                      <span className="">
                        {lists.BuildingNumberPermanent || "-"}
                        {lists.BuildingNumberPermanent ? ", " : ""}
                        {lists.StreetNamePermanent || "-"}
                      </span>
                    </p>
                  </div>

                  <div className="forms mb-2">
                    <p className="confirm_value my-1">
                      {" "}
                      <span className="">
                        {lists.AreaPermanent || "-"}
                        {lists.AreaPermanent ? ", " : ""}
                        {lists.LandmarkPermanent || "-"}
                      </span>
                    </p>
                  </div>

                  <div className="forms mb-2">
                    <p className="confirm_value my-1">
                      {" "}
                      <span className="">
                        {lists.TalukPermanent || "-"}
                        {lists.TalukPermanent ? ", " : ""}
                        {lists.PostPermanent || "-"}
                      </span>
                    </p>
                  </div>

                  <div className="forms mb-2">
                    <p className="confirm_value my-1">
                      {" "}
                      <span className="">
                        {lists.PincodePermanent || "-"}
                        {lists.PincodePermanent ? ", " : ""}
                        {lists.CityPermanent || "-"}
                      </span>
                    </p>
                  </div>

                  <div className="forms mb-2">
                    <p className="confirm_value my-1">
                      <span className="">
                        {lists.districtPermanent || "-"}
                        {lists.districtPermanent ? ", " : ""}
                        {lists.statePermanent || "-"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        {educationQualification.includes("UG") && (
          <fieldset className="mt-3">
            <legend className="w-auto">UG</legend>
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Certificate Number</p>
                      <p className="confirm_value my-1">
                        {" "}
                        {sslcCerficates[0].UGCertificateNumber || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Year of Passing</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[0].UGYearpassing || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Degree</p>
                      <p className="confirm_value my-1">
                        {" "}
                        {sslcCerficates[0].UGDegree || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Major</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[0].UGMajor || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Marks Percentage</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[0].UGMarksPercentage || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Class</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[0].UGClassName || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Name of the college / university
                      </p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[0].UGNameInstitute || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Uploaded UG Certificate
                        {sslcCerficates[0].UG_Path && (
                          <a
                            target="_blank"
                            href={`${ImageUrlPrefix}/${sslcCerficates[0].UG_Path}`}
                          >
                            {" "}
                            <Download className="download_icon" />
                          </a>
                        )}
                      </p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[0].original_file_path || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        )}

        {educationQualification.includes("PG") && (
          <fieldset className="mt-3">
            <legend className="w-auto">PG</legend>
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Certificate Number</p>
                      <p className="confirm_value my-1">
                        {" "}
                        {sslcCerficates[1].PGCertificateNumber || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Year of Passing</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[1].PGYearpassing || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Degree</p>
                      <p className="confirm_value my-1">
                        {" "}
                        {sslcCerficates[1].PGDegree || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Major</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[1].PGMajor || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Marks Percentage</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[1].PGMarksPercentage || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Class</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[1].PGClassName || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Name of the college / university
                      </p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[1].PGNameInstitute || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Uploaded UG Certificate
                        {sslcCerficates[1].PG_Path && (
                          <a
                            target="_blank"
                            href={`${ImageUrlPrefix}/${sslcCerficates[1].PG_Path}`}
                          >
                            {" "}
                            <Download className="download_icon" />
                          </a>
                        )}
                      </p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[1].original_file_path || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        )}

        {educationQualification.includes("Integrated PG") && (
          <fieldset className="mt-3">
            <legend className="w-auto">Integrated PG</legend>
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Certificate Number</p>
                      <p className="confirm_value my-1">
                        {" "}
                        {sslcCerficates[2].IPCertificateNumber || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Year of Passing</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[2].IPYearpassing || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Degree</p>
                      <p className="confirm_value my-1">
                        {" "}
                        {sslcCerficates[2].IPDegree || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Major</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[2].IPMajor || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Marks Percentage</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[2].IPMarksPercentage || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Class</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[2].IPClassName || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Name of the college / university
                      </p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[2].IPNameInstitute || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Uploaded UG Certificate
                        {sslcCerficates[2].IP_Path && (
                          <a
                            target="_blank"
                            href={`${ImageUrlPrefix}/${sslcCerficates[2].IP_Path}`}
                          >
                            {" "}
                            <Download className="download_icon" />
                          </a>
                        )}
                      </p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[2].original_file_path || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        )}

        {educationQualification.includes("phd") && (
          <fieldset className="mt-3">
            <legend className="w-auto">PHD</legend>
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Certificate Number</p>
                      <p className="confirm_value my-1">
                        {" "}
                        {sslcCerficates[3].PHDCertificateNumber || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Year of Passing</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[3].PHDYearpassing || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Degree</p>
                      <p className="confirm_value my-1">
                        {" "}
                        {sslcCerficates[3].PHDDegree || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Major</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[3].PHDMajor || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Marks Percentage</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[3].PHDMarksPercentage || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Class</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[3].PHDClassName || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Name of the college / university
                      </p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[3].PHDNameInstitute || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Uploaded UG Certificate
                        {sslcCerficates[3].PHD_Path && (
                          <a
                            target="_blank"
                            href={`${ImageUrlPrefix}/${sslcCerficates[3].PHD_Path}`}
                          >
                            {" "}
                            <Download className="download_icon" />
                          </a>
                        )}
                      </p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[3].original_file_path || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        )}

        {educationQualification.includes("Diploma") && (
          <fieldset className="mt-3">
            <legend className="w-auto">Diploma</legend>
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Certificate Number</p>
                      <p className="confirm_value my-1">
                        {" "}
                        {sslcCerficates[4].DCertificateNumber || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Year of Passing</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[4].DYearpassing || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Degree</p>
                      <p className="confirm_value my-1">
                        {" "}
                        {sslcCerficates[4].DDegree || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Major</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[4].DMajor || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Marks Percentage</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[4].DMarksPercentage || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Class</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[4].DClassName || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Name of the college / university
                      </p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[4].DNameInstitute || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Uploaded UG Certificate
                        {sslcCerficates[4].D_Path && (
                          <a
                            target="_blank"
                            href={`${ImageUrlPrefix}/${sslcCerficates[4].D_Path}`}
                            className="ms-2"
                          >
                            <Download className="download_icon" />
                          </a>
                        )}
                      </p>

                      <p className="confirm_value my-1">
                        {sslcCerficates[4].original_file_path || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        )}

        {educationQualification.includes("Professional Courses") && (
          <fieldset className="mt-3">
            <legend className="w-auto">Professional Courses</legend>
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Certificate Number</p>
                      <p className="confirm_value my-1">
                        {" "}
                        {sslcCerficates[5].PCCertificateNumber || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Year of Passing</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[5].PCYearpassing || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Degree</p>
                      <p className="confirm_value my-1">
                        {" "}
                        {sslcCerficates[5].PCDegree || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Major</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[5].PCMajor || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Marks Percentage</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[5].PCMarksPercentage || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Class</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[5].PCClassName || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Name of the college / university
                      </p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[5].PCNameInstitute || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Uploaded UG Certificate
                        {sslcCerficates[5].PC_Path && (
                          <a
                            target="_blank"
                            href={`${ImageUrlPrefix}/${sslcCerficates[5].PC_Path}`}
                            className="ms-2"
                          >
                            <Download className="download_icon" />
                          </a>
                        )}
                      </p>

                      <p className="confirm_value my-1">
                        {sslcCerficates[5].original_file_path || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        )}

        {educationQualification.includes("Others") && (
          <fieldset className="mt-3">
            <legend className="w-auto">Others</legend>
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Certificate Number</p>
                      <p className="confirm_value my-1">
                        {" "}
                        {sslcCerficates[6].OtCertificateNumber || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Year of Passing</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[6].OtYearpassing || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Degree</p>
                      <p className="confirm_value my-1">
                        {" "}
                        {sslcCerficates[6].OtDegree || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Major</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[6].OtMajor || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Marks Percentage</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[6].OtMarksPercentage || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Class</p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[6].OtClassName || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Name of the college / university
                      </p>
                      <p className="confirm_value my-1">
                        {sslcCerficates[6].OtNameInstitute || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Uploaded UG Certificate
                        {sslcCerficates[6].Ot_Path && (
                          <a
                            target="_blank"
                            href={`${ImageUrlPrefix}/${sslcCerficates[6].Ot_Path}`}
                            className="ms-2"
                          >
                            <Download className="download_icon" />
                          </a>
                        )}
                      </p>

                      <p className="confirm_value my-1">
                        {sslcCerficates[6].original_file_path || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        )}

        {techQualification.map((el, index) => (
          <div className="col-md-12" key={index}>
            <fieldset className="mt-3">
              <legend className="w-auto">
                Technical Qualification{" "}
                {techQualification.length > 1 ? `- ${el.id}` : ""}
              </legend>

              <div className="row mb-3">
                <div className="col-md-12">
                  <div className="row">
                    {/* Technical Course */}
                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">Technical Course</p>
                        <p className="confirm_value my-1">{el.name || "-"}</p>
                      </div>
                    </div>

                    {/* Typewriting Level */}
                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">Typewriting Level</p>
                        <p className="confirm_value my-1">{el.level || "-"}</p>
                      </div>
                    </div>

                    {/* Language */}
                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">Language</p>
                        <p className="confirm_value my-1">{el.lang || "-"}</p>
                      </div>
                    </div>

                    {/* Certificate Number */}
                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">Certificate Number</p>
                        <p className="confirm_value my-1">{el.Cnum || "-"}</p>
                      </div>
                    </div>

                    {/* Grade */}
                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">Grade</p>
                        <p className="confirm_value my-1">{el.grade || "-"}</p>
                      </div>
                    </div>

                    {/* Year of Passing */}
                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">Year of Passing</p>
                        <p className="confirm_value my-1">{el.year || "-"}</p>
                      </div>
                    </div>

                    {/* Upload Certificate */}
                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">
                          Upload Certificate
                          {el.file && (
                            <a
                              target="_blank"
                              href={`${ImageUrlPrefix}/${el.file}`}
                              rel="noopener noreferrer"
                            >
                              <Download
                                className="download_icon"
                                style={{ opacity: 1 }}
                              />
                            </a>
                          )}
                        </p>
                        <p className="confirm_value my-1">
                          {el.original_file_path || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        ))}

        <fieldset className="mt-3">
          <legend className="w-auto">
            {" "}
            Special / Preferential Qualification (if any)
          </legend>
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Special / Preferential Qualification
                    </p>
                    <p className="confirm_value my-1">{lists.spq || "-"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset className="mt-3">
          <legend className="w-auto">Previous Experience</legend>
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Do you have any previous working or teaching experience?
                    </p>
                    <p className="confirm_value my-1">
                      {lists.prevTeachexp === "Yes" ? "Yes" : "No" || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Working Experience</p>
                    <p className="confirm_value my-1">
                      {lists.prevTeachexp === "Yes" ? lists.workingexp : "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Teaching Experience</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {lists.prevTeachexp === "Yes" ? lists.teachexp : "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Working Experience File{" "}
                      {lists.working_ex_file !== "" &&
                        lists.working_ex_file !== null && (
                          <a
                            href={`${ImageUrlPrefix}/${lists.working_ex_file}`}
                            target="_blank"
                            download
                          >
                            <span className="material-icons align-middle download_icon">
                              file_download
                            </span>
                          </a>
                        )}
                    </p>
                    <p className="confirm_value my-1">
                      {lists.prevTeachexp === "Yes"
                        ? lists.original_workexp
                        : "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Teaching Experience File{" "}
                      {lists.Teaching_ex_file !== "" &&
                        lists.Teaching_ex_file !== null && (
                          <a
                            href={`${ImageUrlPrefix}/${lists.Teaching_ex_file}`}
                            target="_blank"
                            download
                          >
                            <span className="material-icons align-middle download_icon">
                              file_download
                            </span>
                          </a>
                        )}
                    </p>
                    <p className="confirm_value my-1">
                      {lists.prevTeachexp === "Yes"
                        ? lists.original_teachexp
                        : "-"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        {staffType !== 3 ? (
          <>
            <fieldset className="mt-3">
              <legend className="w-auto">Current Job Info</legend>
              <div className="row mb-3">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">Job Type</p>
                        <p className="confirm_value my-1">
                          {lists.teachType === "1"
                            ? "Teaching"
                            : "NonTeaching" || "-"}
                        </p>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">Designation</p>
                        <p className="confirm_value my-1">
                          {lists.designation || "-"}
                        </p>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">Date of Joining</p>
                        <p className="confirm_value my-1">
                          {lists.DJoin || "-"}
                        </p>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">Branch Location</p>
                        <p className="confirm_value my-1">
                          {lists.location_name || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </>
        ) : (
          <>
            {addJob.map((el, index) => (
              <div className="col-md-12" key={index}>
                <fieldset className="mt-3">
                  <legend className="w-auto">
                    Current Job Info {addJob.length > 1 ? `- ${el.id}` : ""}
                  </legend>

                  <div className="row mb-3">
                    <div className="col-md-12">
                      <div className="row">
                        {/*   Department */}
                        <div className="col-lg-3 col-md-6 col-12 mb-3">
                          <div className="d-flex flex-column">
                            <p className="confirm_label m-0"> Department</p>
                            <p className="confirm_value my-1">
                              {" "}
                              {el.department || "-"}
                            </p>
                          </div>
                        </div>

                        {/* Designation */}
                        <div className="col-lg-3 col-md-6 col-12 mb-3">
                          <div className="d-flex flex-column">
                            <p className="confirm_label m-0">Designation</p>
                            <p className="confirm_value my-1">
                              {el.exp_designation || "-"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            ))}
          </>
        )}

        <fieldset className="mt-3">
          <legend className="w-auto">Voice Your Opinion</legend>
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Insights and Proposals</p>
                    <p className="confirm_value my-1">
                      {lists.VoiceOpinion || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        {remarks &&
          remarks.length > 0 &&
          remarks.map((el, index) => (
            <fieldset className="mt-3">
              <legend className="w-auto">Remark by Admin - {el.date} </legend>
              <div className="row mb-3">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">Remark by Admin</p>
                        <p className="confirm_value my-1">{el.comments}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          ))}

        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Remark by Admin
                </h5>
                <button
                  type="button"
                  ref={modalCloseRef}
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="forms">
                  <label htmlFor="remarks" className="form-labels">
                    Remark by Admin
                  </label>
                  <textarea
                    name="remarks"
                    id="remarks"
                    value={lists.remarks}
                    onChange={handleChange}
                    className="InputsTextarea"
                    placeholder="Remark by Admin"
                    style={{ marginLeft: 0 }}
                  />
                  {error.remarks && (
                    <small className="error_message">{error.remarks}</small>
                  )}
                </div>
              </div>

              <div className="modal-footer">
                <div className="col-md-12 d-flex justify-content-end">
                  <ul className="List-Button d-flex p-0 m-0 gap-2">
                    {/* Back Link */}
                    <li className="ListBtnItems">
                      <Link
                        to="#"
                        className="secondaryButton"
                        data-bs-dismiss="modal"
                      >
                        Back to View Faculty Profile
                      </Link>
                    </li>

                    {/* Add Remarks Link */}
                    <li className="ListBtnItems">
                      <Link
                        to="javascript:void(0)"
                        className="primaryButton d-flex align-items-center justify-content-center text-center"
                        onClick={handleRemarks}
                      >
                        Add Remarks
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
